import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { ExpenseTypeAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-expense-type-audit-list',
  templateUrl: './expense-type-audit-list.component.html',
  styleUrls: ['./expense-type-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpenseTypeAuditListComponent implements OnInit {
  @Input() expenseTypeId: number;
  @Input() loading: boolean;
  @Input() expenseTypeAudits: ExpenseTypeAudit[];

  @Output() loadExpenseType = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadExpenseType.emit(this.expenseTypeId);
  }

  onNextPage() {
    this.nextPage.emit(this.expenseTypeId);
  }
}
